/* RESPONSIBLE TEAM: team-omni */
import type AppService from 'embercom/services/app-service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Transition from '@ember/routing/-private/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class SlackRoute extends SettingsRoute {
  @service declare permissionsService: $TSFixMe;
  @service declare appService: AppService;
  @service declare intl: IntlService;

  reactEnabled() {
    return (
      this.appService.app.canUseSlackChannel && this.appService.app.canUseFeature('team-omni-slack')
    );
  }

  get titleToken() {
    return this.intl.t('new-settings.channels.slack.title');
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);
    return this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_product_settings',
      transition,
    );
  }
}

export default ReactRoute(SlackRoute);
